module.exports = __webpack_public_path__ + "img/vision.d9d3c3ad.svg";